/**
 * 物流信息管理
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2023, all rights reserved. Essa.cn
 */
import React,{PureComponent} from 'react';
import { Space, Spin,message} from "antd";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import AutoFetchTable from "@/components/AutoFetchTable/AutoFetchTable";
import AuthBtn from "@components/HoverIcon/AuthBtn";
import EssaModal from '@components/EssaModal/EssaModal';
import Lang from "@/components/Lang/Lang";
import LogisticsAction from "./Logistics.action";
import {isEmpty,getFileSuffix} from '@utils/utils';
import Edit from './edit';// 新增及编辑
import "./index.less";
export default class Logistics extends PureComponent{
    constructor(props) {
        super(props);
        this.state = {
            currentPage:1,//当前页
            loading: false,
            showDeleteModal:false,
            showDeleteId:"",
            // 表单 配置
            searchFormOptions:[
                {
                    name:'keyword',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'支持搜索服务城市/物流公司',
                    cnPlaceholderId:'ZhiChiSouSuoFuWuChengShiWuLiuGongSi',
                    width:256,
                },
            ],
            // 表格
            columns:[
                {
                    cnTitle: '物流公司',
                    cnTitleId: 'WuLiuGongSi',
                    dataIndex: 'name',
                    width:200,
                    render:  (text, record, index) => (
                        <span className={"fw_700 black89"}>{text}</span>
                    )
                },
                {
                    cnTitle: '联系人',
                    cnTitleId: 'LianXiRen',
                    dataIndex: 'contactList',
                    width:200,
                    render:(contactList=[], record, index) => (<div className={"black89"}>
                        {contactList.map((person,inx)=><p key={"per_"+inx}>
                            <span className={"fw_500"}>{person.name}</span><span className={"ml_8 black45"}>+{person.telCode} {person.mobile}</span>
                        </p>)}
                    </div> )
                },
                {
                    cnTitle: '覆盖城市',
                    cnTitleId: 'FuGaiChengShi',
                    dataIndex: 'cityNames',
                    width:350,
                    render:(text, record, index) => (<div className={"black89"}>
                        <div className={"ellipsis-line2"}>
                            {text}
                        </div>
                    </div> )
                },
                {
                    cnTitle: '操作',
                    dataIndex: 'CaoZuo',
                    width: 120,
                    cnTitleId: 'CaoZuo',
                    render: (item = {}, record) => (
                        <Space>
                            <Edit id={record.id} refreshPage={()=>this.refreshPage()}>
                                <AuthBtn icon={"ri-edit-line"} tips = {Lang({id:"BianJi",default:"编辑"})} />
                            </Edit>
                            <AuthBtn icon={"ri-delete-bin-line"} tips = {Lang({id:"ShanChu",default:"删除"})}
                                     onClick={()=>this.showDelete(true,record.id)} />
                        </Space>

                    ),
                },
            ],
        }
    }
    // 删除
    showDelete(flag,id){
        this.setState({
            showDeleteModal:flag,
            showDeleteId:id
        })
    }
    delete(){
        const {showDeleteId } = this.state;
        console.log("id",showDeleteId)
        if(isEmpty(showDeleteId)){
            return
        }
        LogisticsAction.delete({
            idList:[showDeleteId]
        }).then(res=>{
            const resData = res.data;
            const { success, valid} = resData;
            if (success &&valid) {
                // 保存成功
                this.showDelete(false);
                this.refreshPage();// 刷新 页面数据
            }else if(resData.message){
                message.warning(resData.message)
            }else {
                message.warning(Lang({id:"BaoCunShiBai"}))
            }
        })
    }
    // 查询回调
    fetchCallBack(res={}){
        console.log("res",res)
        const { paging={} } = res;
        this.setState({
            currentPage: paging.pageNum||1
        })
    }
    refreshPage(){
        if (this.onPageTemplateTableChild) {
            const { currentPage } = this.state;
            this.onPageTemplateTableChild.handleFetch(currentPage,{},true);
        }
    }
    onRefTabOne = (ref) =>  this.onPageTemplateTableChild = ref;
    componentDidMount() {
    }
    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        }
    }
    render(){
        const {  loading,columns, searchFormOptions,showDeleteModal } = this.state;
        const currPageName =  Lang({id: 'WuLiuXinXiGuanLi', default: '物流信息管理'})
        return (<Spin tip='loading' spinning={loading}>
                    <CommonBreadcrumb list={[
                        {name:currPageName},
                    ]}></CommonBreadcrumb>
                    <div className={"page-wrap"}>
                            <div className="new-link flex-item mb_12">
                                <span className="font-title fw_700 font_18 mr_10"> {currPageName}</span>
                                <Edit refreshPage={()=>this.refreshPage()}>
                                    <div className="color-danger flex-item-ver-center">
                                        <i className="ri-add-circle-line mr_2 font-18"></i>
                                        <span className="font_14"> {Lang({id: "XinZeng",default: "新增"})}</span>
                                    </div>
                                </Edit>
                            </div>
                            <AutoFetchTable columns={columns}
                                            onRef={this.onRefTabOne}
                                            fetchCallBack={(data)=>this.fetchCallBack(data)}
                                            flagShowReset={false}
                                            pageSize={10}
                                            fetchApi={'/service/mg/whs/logistics/company/list'}
                                            searchFormOptions={searchFormOptions} />
                 </div>
                {/* 操作 END */}
                {showDeleteModal&&<EssaModal title={Lang({id: "TiShi",default: "提示"})}
                                           open={showDeleteModal}
                                           width={600}
                                           onOk={()=>this.delete()}
                                           onCancel={()=>this.showDelete(false)}>
                    <p className="padding-bottom-10">
                        {Lang({id: "ShanChuHouBuYingXiangYiTuiJianDeDingDan",default: `删除后不影响已推荐的订单，是否要删除该物流公司？`,})}
                    </p>
                </EssaModal>}
            </Spin>
        )
    }
}

